export const KeyboardUtil = {
    keyTab: 9,
    keyEnter: 13,
    keyShift: 16,
    keyCtrl: 17,
    keyAlt: 18,
    keyEscape: 27,
    keyWhitespace: 32,
    keyArrowLeft: 37,
    keyArrowUp: 38,
    keyArrowRight: 39,
    keyArrowDown: 40
};
